import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
  AutocompleteInput,
  NotificationsContext,
} from '@kirz/mui-admin';
import { Box } from '@mui/material';
import React, {
  forwardRef,
  Ref,
  useContext,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const SuppliersTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const { showAlert } = useContext(NotificationsContext);
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'name',
            selector: 'firstName lastName',
            headerName: 'Naam',
            onSort(sort) {
              return [{ firstName: sort }];
            },
            valueGetter({ row }) {
              return `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim();
            },
            flex: 1,
          },
          {
            field: 'phone',
            headerName: 'Telefoon',
            flex: 1,
          },
          {
            field: 'email',
            headerName: 'E-mail',
            flex: 1,
            // type: 'email',
            renderCell({ row }) {
              return (
                <Box
                  component="a"
                  sx={{
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                    color: 'inherit',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(row.email);
                    showAlert('Copied to clipboard', 'success');
                  }}
                >
                  {row.email}
                </Box>
              );
            },
          },
          {
            field: 'companyName',
            headerName: 'Bedrijf',
            flex: 1,
          },
          { field: 'createdAt', headerName: 'Aangemaakt op', type: 'date' },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="supplier"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          onEdit(row) {
            tableRef.current?.openFormDialog(row);
          },
        }}
        formTitle={(isNew) =>
          isNew ? 'Nieuwe leverancier' : 'Leverancier bewerken'
        }
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'md',
        }}
      >
        <FormInput name="firstName" label="Voornaam" md={6} required />
        <FormInput name="lastName" label="Achternaam" md={6} required />
        <FormInput name="phone" label="Telefoon" md={4} />
        <FormInput name="email" label="E-mail" md={4} />
        <FormInput name="companyName" label="Bedrijf" md={4} />
      </DataTableEx>
    );
  },
);
